<head *ngIf="theme">
    <title>{{title}}</title>
    <link [href]="theme.font | safe: 'resourceUrl'" rel="stylesheet">
</head>

<div class="main-content" #main *ngIf="theme">
    <app-header [logoSrc]="theme.header.img" [lang]="selectedLang"></app-header>
    <app-loader *ngIf="isLoading$ | async"></app-loader>
    <app-wifi-connection-loader></app-wifi-connection-loader>
    <router-outlet></router-outlet>
</div>
